import React from 'react';
import { AccessRowData } from './style';
import { SelectWithPencil } from '../../components/Select/SelectWithPencil/index';
import { getUserAccessBasedOnRole } from '../../consts/userRoles';

export const getManageUsersTableColumns = ({
  selectEditingState,
  setSelectEditingState,
  selectOptions,
  onApproveButtonClick
}) => [
  {
    title: 'Email',
    key: 'email',
    render: data => {
      return <div>{data.email}</div>;
    }
  },
  {
    title: 'Member Name',
    key: 'member_name',
    render: data => {
      return <div>{data.name}</div>;
    }
  },
  {
    title: 'Role',
    key: 'created_at',
    render: data => {
      return (
        <SelectWithPencil
          id={data.azure_object_id}
          selectEditingState={selectEditingState}
          setSelectEditingState={setSelectEditingState}
          selectOptions={selectOptions}
          onApproveButtonClick={params =>
            onApproveButtonClick({ ...params, user_id: data?.azure_object_id })
          }
          text={data.role}
        />
      );
    }
  },
  {
    title: 'Access',
    key: 'access',
    render: data => {
      return <AccessRowData>{getUserAccessBasedOnRole(data.role)}</AccessRowData>;
    }
  }
];
